// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-Report-ExpensesReport-Chart-DoughnutChart-style__doughnutWrapper--t3c3d{display:flex;flex-direction:row}.src-Report-ExpensesReport-Chart-DoughnutChart-style__doughnutWrapper--t3c3d .src-Report-ExpensesReport-Chart-DoughnutChart-style__doughnutContainer--YdGE3{width:50%;position:relative}.src-Report-ExpensesReport-Chart-DoughnutChart-style__doughnutWrapper--t3c3d .src-Report-ExpensesReport-Chart-DoughnutChart-style__doughnutContainer--YdGE3 h1{position:absolute;top:50%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"doughnutWrapper": "src-Report-ExpensesReport-Chart-DoughnutChart-style__doughnutWrapper--t3c3d",
	"doughnutContainer": "src-Report-ExpensesReport-Chart-DoughnutChart-style__doughnutContainer--YdGE3"
};
export default ___CSS_LOADER_EXPORT___;
